import React from "react";
import { LayerControl as RimeLayerControl } from "@mrwa/rime-replacement/esriControls/controls/layer/LayerControl";
import AddCustomLayerTool from "@mrwa/rime-replacement/esriControls/tools/AddCustomLayerTool";

export default class LayerControl extends RimeLayerControl {
  static componentName = "roadViewLayerControl";

  async componentDidMount() {
    await super.componentDidMount();

    if (this.props.setHeaderButtons) {
      this.props.setHeaderButtons(
        <div>
          <AddCustomLayerTool view={this.props.view} />
        </div>
      );
    }
  }
}
